module.exports = __webpack_public_path__ + "5258777687fa31476df7d5ee3245f0cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/weight.svg
// module id = 791
// module chunks = 0